var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mkt-table-join-data",on:{"click":_vm.eventEmitClick}},[_vm._v("\n\t\t"+_vm._s(_vm.joinVariationData(_vm.rowData))+"\n  ")])}
var staticRenderFns = []

export { render, staticRenderFns }